import React from 'react';
import './WebflowSection.css';

const WebflowSection = () => {
  return (
    <section className="webflow-section">
      <div className="container">
      <div className="webflow-overlay">
        <div className="webflow-content">
          <div className="webflow-left">
            <h2>
              WE ARE A WEBFLOW <br />ENTERPRISE PARTNER
            </h2>
            <div className="webflow-images">
              <img src="/webflow1.webp" alt="WF1" />
              <img src="/webflow2.png" alt="WF2" />
            </div>
          </div>
          <div className="webflow-right">
            <p>
             Besides being a software & web application development company, we are also a digital incubator. As a Webflow-endorsed partner, we are constantly looking for fresh and intuitive ways to stimulate the metamorphosis of both new and existing digital projects. From technology to healthcare, finance to travel, we help clients for various industries grow their digital presence through Webflow.
            </p>
            <img src="/webflow3.webp" alt="WF3" className="webflow-main-img" />
          </div>
        </div>
      </div>
      </div>
    </section>
  );
};

export default WebflowSection;
